export default (state = false, action = {}) => {
  switch (action.type) {
    case 'APPLICATION_ERROR':
      return action.payload;
    default:
      return state;
  }
};
